import React from 'react';
import Dialog from 'screens/shared/dialog';
import { DialogContentText, Button } from '@mui/material';
import Icon from 'screens/shared/icon';
import { _t } from 'utils';

export default ({
  show = false,
  title = '',
  message = '',
  onClose = null,
  type = 'success',
}) => {
  const actions = (
    <>
      <Button onClick={onClose} color="primary" autoFocus>
        {_t('Close')}
      </Button>
    </>
  );

  const content = (
    <div className={`dialog-${type}`}>
      <Icon name={type === 'success' ? 'check-circle' : 'trash'} />
      <DialogContentText className="message">{message}</DialogContentText>
    </div>
  );

  return (
    <Dialog
      show={show}
      actions={actions}
      content={content}
      title={title}
      onClose={onClose}
    />
  );
};
